import styles from './Policy.module.css';

export const Policy = () => {
  return (
    <div className={styles.container}>
      <h5>How we use your personal information</h5>
      <p>
        We’ll share it with credit reference agencies to run identity checks and
        with fraud prevention agencies. Also, we might record some of your calls
        with us.
      </p>
      <p>
        This doesn’t affect your personal credit score but if we do spot fraud,
        you could be refused services, finance or employment.
      </p>
      <p className={styles.disclaimer}>
        Read our{' '}
        <a
          href="/privacy-policy/"
          className={styles.link}
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>
        , iwoca Ltd. is the data controller
      </p>
    </div>
  );
};
